feedAuthApp.controller('LoginController', ['$scope', '$routeParams', 'AuthStateService', function($scope, $routeParams, AuthStateService) {
	$scope.isCurrentView = (view) => {
		return AuthStateService.getView() === view;
	};

	if ($routeParams['app']) {
		AuthStateService.setApp(decodeURIComponent($routeParams['app']));
	}

	if ($routeParams['authApps']) {
		AuthStateService.setAuthApps(decodeURIComponent($routeParams['authApps']));
	}
	
	if ($routeParams['legacy_feedsupport_redirect']) {
		const legacyFeedsupportRedirectValue = decodeURIComponent($routeParams['legacy_feedsupport_redirect']);
		if (legacyFeedsupportRedirectValue === '1') {
			AuthStateService.setLegacyFeedsupportRedirect(true);
		}
	}
    
    if ($routeParams['sign_in_with_bc']) {
		const signInWithBC = decodeURIComponent($routeParams['sign_in_with_bc']);
        if (signInWithBC === '1') {
            AuthStateService.setSignInWithBC(true);
        }
    }

	if ($routeParams['redirect']) {
		AuthStateService.setRedirect(decodeURIComponent($routeParams['redirect']));
	}

	if ($routeParams['referrer']) {
		AuthStateService.setReferrer($routeParams['referrer']);
	}

	if ($routeParams['session']) {
		AuthStateService.setSession($routeParams['session']);
	}
}]);